exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ButtonContainer__actions___3WfcK {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box; }\n  .ButtonContainer__actions___3WfcK button:nth-child(1) {\n    border-radius: 0px 0px 0px 6px; }\n  .ButtonContainer__actions___3WfcK button:nth-child(2) {\n    border-radius: 0px 0px 6px 0px; }\n", ""]);

// exports
exports.locals = {
	"actions": "ButtonContainer__actions___3WfcK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/DialogComponents/Buttons/ButtonContainer/ButtonContainer.scss
// module id = 721
// module chunks = 0